const ENVS = {
	DEVELOPMENT: 'development',
	PRODUCTION: 'production',
	STAGING: 'staging',
};

const cloudinaryDomainSuffix = '.cloudinary.com';
const stagingSubDomainPrefix = ENVS.STAGING;

const getCloudinarySubDomain = () => {
	const hostname = window.location.hostname.toLowerCase() || '';
	return hostname.endsWith(cloudinaryDomainSuffix) ? hostname.split('.')[0] : null;
};

const getEnvNamesForValue = (value) => {
	if (value.startsWith(stagingSubDomainPrefix)) {
		return ENVS.STAGING;
	}

	return ENVS.PRODUCTION;
};

const getEnvFromUrl = () => {
	const subDomain = getCloudinarySubDomain();

	if (subDomain) {
		return getEnvNamesForValue(subDomain);
	}
};

let version = localStorage.getItem("uw-version");
let environment = "https://upload-widget" + (getEnvFromUrl() === "staging" ? "-staging" : "") + ".cloudinary.com/";
export const widgetUrl = environment + (version ? version + "/" : "") + "global/all.js";
